import { client } from '@passwordless-id/webauthn';
import { useContext, useEffect } from 'react';

import { MessagingContext } from '@sorare/wallet-shared';
import type { GetPasskeyEncryptionKey } from '@sorare/wallet-shared/src/contexts/messaging';
import { prf, prfResult } from 'lib/passkeys';

import { useGeneratePasskeyChallenge } from './useGeneratePasskeyChallenge';

export const useGetPasskeyEncryptionKey = () => {
  const { registerHandler } = useContext(MessagingContext)!;
  const generatePasskeyChallenge = useGeneratePasskeyChallenge();

  useEffect(
    () =>
      registerHandler<GetPasskeyEncryptionKey>(
        'getPasskeyEncryptionKey',
        async ({ passkeyIds }) => {
          const challenge = await generatePasskeyChallenge();
          const passkey = await client.authenticate({
            challenge,
            allowCredentials: passkeyIds,
            customProperties: {
              extensions: {
                prf,
              },
            },
          });

          return {
            result: {
              encryptionKey: prfResult(passkey),
              passkeyId: passkey.rawId,
            },
          };
        }
      ),
    [registerHandler, generatePasskeyChallenge]
  );
};
